import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import BirthdayPartiesPage from "./pages/BirthdayPartiesPage";
import CoachesPage from "./pages/CoachesPage";
import ClassesPage from "./pages/ClassesPage";
import LocationsPage from "./pages/LocationsPage";
import TermsPage from "./pages/TermsPage";
import AdminPage from "./pages/AdminPage";
import GalleryPage from "./pages/GalleryPage";
import GalleryAdminPage from "./pages/GalleryAdminPage";
import EventsPage from "./pages/EventsPage";
import EventDetailPage from "./pages/EventDetailPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import SPStaffPortal from "./pages/SPStaffPortal";
import SPAdmin from "./pages/SPAdmin";
import FindAClassModal from "./components/FindAClassModal";
import { FindAClassProvider } from "./context/FindAClassContext";
import { BookingLinksProvider } from "./context/BookingLinksContext";
import { SiteImagesProvider } from "./context/SiteImagesContext";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <SiteImagesProvider>
      <BookingLinksProvider>
      <FindAClassProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/birthday-parties" element={<BirthdayPartiesPage />} />
            <Route path="/coaches" element={<CoachesPage />} />
            <Route path="/classes" element={<ClassesPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/events/:eventId" element={<EventDetailPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/locations" element={<LocationsPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/gallery/admin" element={<GalleryAdminPage />} />
            <Route path="/stayandplay/staff" element={<SPStaffPortal />} />
            <Route path="/stayandplay/admin" element={<SPAdmin />} />
          </Routes>
          <FindAClassModal />
        </BrowserRouter>
      </FindAClassProvider>
      </BookingLinksProvider>
      </SiteImagesProvider>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
